<template>

  <v-navigation-drawer app="app" clipped="clipped" fixed="fixed" v-model="drawer">
    <v-list>
      <router-link class="menu-entry"
                   tag="v-list-tile"
                   value="true"
                   v-for="(entry, index) of entries"
                   :key="index"
                   :to="entry.url"
                   :class="$route.path === entry.url ? 'selected' : ''">
        <v-list-tile-action>{{ entry.label }}</v-list-tile-action>
      </router-link>
    </v-list>
  </v-navigation-drawer>

</template>

<script>

export default {
  name: 'MainMenu',
  props: ['value'],
  data () {
    return {
      drawer: this.$route.path === '/',
      entriesList: [
        {
          url: '/',
          label: 'Home',
          countries: ['FR', 'US']
        },
        {
          url: '/matchesthisweek',
          label: 'Matches this week',
          countries: ['FR', 'US']
        },
        {
          url: '/sports',
          label: 'Sports',
          countries: ['FR', 'US']
        },
        {
          url: '/federations',
          label: 'Federations',
          countries: ['FR', 'US']
        },
        {
          url: '/competitions',
          label: 'Competitions',
          countries: ['FR', 'US']
        },
        {
          url: '/places',
          label: 'Places',
          countries: ['FR', 'US']
        },
        {
          url: '/clubs',
          label: 'Clubs',
          countries: ['FR', 'US']
        },
        {
          url: '/teams',
          label: 'Teams',
          countries: ['US']
        },
        {
          url: '/matches',
          label: 'Matches',
          countries: ['FR', 'US']
        },
        {
          url: '/videos',
          label: 'Videos',
          countries: ['FR', 'US']
        },
        {
          url: '/users',
          label: 'Users',
          countries: ['FR', 'US']
        },
        {
          url: '/notifications',
          label: 'Notifications',
          countries: ['FR', 'US']
        },
        {
          url: '/topactions',
          label: 'Top Actions',
          countries: ['FR']
        },
        {
          url: '/clips',
          label: 'Clips',
          countries: ['FR', 'US']
        }
      ]
    }
  },
  computed: {
    entries () {
      let entries = []
      for (let entry of this.entriesList) {
        if (entry.countries.includes(this.$country)) {
          entries.push(entry)
        }
      }
      return entries
    }
  },
  watch: {
    drawer (val) {
      this.$emit('input', val)
    },

    value (val, old) {
      if (val !== old) {
        this.drawer = val
      }
    }
  }
}

</script>

<style lang="scss" scoped>

@import '../styles/main-colors';

.menu-entry {
  text-decoration: none;
  color: $font-dark;

  &:hover, &.selected {
    background-color: rgba($background-dark, 0.05);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/MainMenu.vue